import { Record } from 'immutable';

export default class RecruitmentAdRecord extends Record({
  id: undefined,
  active: undefined,
  adNumber: undefined,
  applyUntil: undefined,
  city: undefined,
  companyName: undefined,
  contacts: undefined,
  createdAt: undefined,
  createdBy: undefined,
  description: undefined,
  employmentDescription: undefined,
  employmentScheduleDescription: undefined,
  employmentScheduleType: undefined,
  employmentType: undefined,
  internalContact: undefined, // FE Only
  internalContactTitle: undefined, // FE Only
  jobBoards: undefined,
  lastApplicationDate: undefined,
  links: undefined,
  municipality: undefined,
  numberOfPositions: undefined,
  occupation: undefined,
  organisationNumber: undefined,
  postalCode: undefined,
  publishedAt: undefined,
  resourceCount: undefined,
  questionnaire: undefined,
  salaryDescription: undefined,
  salaryType: undefined,
  service: undefined,
  staffingCompany: undefined,
  street: undefined,
  street2: undefined,
  title: undefined,
  url: undefined,
  user: undefined,
  visible: undefined,
  imageContent: undefined,
}) {
}
